import { Router, RouteLocationNormalized, LocationQueryValue } from 'vue-router'

export function getTagsFromUrl(url = window.location.href as string): string[] {
  const key = 'tagIn'

  try {
    const searchParams = new URLSearchParams(url.slice(url.indexOf('?')))
    if (searchParams.has(key)) {
      return searchParams.getAll(key)
    }
    return []
  } catch (e) {
    return [] // if invalid url is provided
  }
}

export function deleteQueryParam(
  router: Router,
  route: RouteLocationNormalized,
  paramName: string,
) {
  const newQuery = Object.assign({}, route.query)
  delete newQuery[paramName]
  router.replace({ ...route, query: newQuery })
}

export function getBusinessSlugFromUrl() {
  const match = window.location.href.match(/\/b\/([^\/]*)\//)
  return match ? match[1] : null
}

export function getArrayFromQuery(
  query: LocationQueryValue | LocationQueryValue[],
): string[] | undefined {
  if (!query) {
    return undefined
  }

  if (typeof query === 'string') {
    return [query]
  }

  const res: string[] = []
  query.forEach((q) => {
    if (q !== null) {
      res.push(q)
    }
  })
  return res
}

export const extractSheetId = (input: string): string => {
  // Matches a full Google Sheets URL and extracts the ID
  const urlPattern =
    /(?:https?:\/\/)?(?:www\.)?docs\.google\.com\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/

  // Matches just the ID format (simplified validation)
  const idPattern = /^[a-zA-Z0-9-_]{20,}$/

  if (idPattern.test(input)) {
    return input // Already a valid ID
  }

  const match = input.match(urlPattern)
  if (match && match[1]) {
    return match[1] // Extracted ID from valid URL
  }

  return ''
}
